/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import en from '@locales/en.json'

// "Last resort" fallback if there is no available locale that matches the user's browser settings.
// MUST match the imported locale file above.
export const DEFAULT_LOCALE = 'en'

// https://vitejs.dev/guide/features#glob-import
// Note regarding aliases: https://github.com/vitejs/vite/pull/12221
const LOCALES = import.meta.glob<{ default: typeof en }>('/locales/*.json')

// Note: we can't use availableLocales from i18n anymore as locales are not immediately loaded.
export const SUPPORTED_LOCALES = Object.keys(LOCALES).map((k) => k.slice('/locales/'.length, -'.json'.length))

export function loadMessages(locale: string) {
  if (!(`/locales/${locale}.json` in LOCALES)) {
    if (locale.includes('-')) {
      console.warn(`Locale ${locale} not found`)
      return loadMessages(locale.split('-')[0])
    }
    console.error(`No such lang ${locale}!`)
  }

  return LOCALES[`/locales/${locale}.json`]().then((m) => m.default)
}

export { en as defaultMessages }
